import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import colors from "../Constant/colors";
import { FaUserShield } from "react-icons/fa";
import axios from "axios";

const Navbar = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [adminName, setAdminName] = useState("Admin");
  const [userType,setUserType]=useState("Admin");
  const [designation, setDesignation] = useState("Admin");

  const routeTitles = {
    "/dashboard": "Dashboard",
  "/gallery": "Gallery","/student-management": "Student Management","/give-salary":"Salary Management", "/attendance-management": "Attendance Management", "/class-management": "Class Management", "/homework-assignments": "Homework & Assignments", "/examination": "Examination Managemnet", "/fee-management": "Fee Management", "/notification-management": "Notification Management", "/salary-management": "Salary Management", "/teacher-management": "Staff Management", "/subject-management": "Subject Management", "/transportation-management": "Transportation Management", "/user-management": "User Management", "/hiring": "Hire Management", "/new-student": "Add New Student", "/student-table": "Student Management Table", "/enroll-guardian": "Enroll Guardian", "/gatepass-management": "Issue Gatepass", "/student-attendance": "Student Attandance", "/student-certificates": "Student Certificates", "/add-attendance": "Attandance Form", "/view-attendance": "Student Attandance", "/create-class": "Create New Class", "/create-section": "Create New Section", "/assign-subject": "Assign Subjects to Classes", "/school-timing": "Create School Timing", "/manage-timetable": "Manage Timetable", "/class-homework": "Assign Homework", "/class-assignments": "Assignment", "/course-material": "Upload Course Material", "/school-leaving-certificate": "School Leaving Certificate", "/dob-certificate": "Date of Birth Certificate", "/character-certificate": "Character Certificate", "/family-income-certificate": "Family Income Certificate", "/add-designation": "Designation Management", "/createOpening": "Create Job Opening", "/viewOpenings": "Current Job Openings", "/exam-datesheet": "Examination Datesheet", "/exam-results": "Exam Results", "/test-schedule": "Test Schedule", "/old-papers": "Old Papers", "/fee-collection": "Fee Collection", "/fee-list": "Class Fee Structure", "/fee-structure/new": "Create Fee Structure", "/fee-heads": "Fee Heads", "/student-ledgers": "Student Ledgers", "/ledgerStaff": "Staff Ledger Management", "/add-notification": "Admin Notifications", "/add-classwise-notification": "Add Classwise Notification", "/add-events": "Events & Activities", "/todays-thought": "Share Today's Thought", "/student-achievement": " Student Achievement", "/school-achievement": " School Achievement", "/new-roles": "Assign Role/ Create Login", "/permissions": "Permissions", "/reset-password": "Admin: Reset User Password", "/school-data": "School Information", "/bus-routes": "Bus Routes", "/bus-location": "Add Route Location", "/manage-bus": "Bus Details Management", "/bus-schedule": "Add New Bus Schedule", "/allocate-student": "Allocate Students to Bus", "/report-management": "Reports Management", "/fee-report": "Fee Reports Management", "/student-report": "Student Reports", "/staff-report": "Staff Report", "/transportation-report": "Transportation Report", "/promote-student": "Promotion Management", "/add-session": "Add Session", "/promote-session": "Student Promotion"
  };

  const pageTitle = routeTitles[location.pathname] || "";

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to log out?")) {
      localStorage.clear();
       navigate("/login", { replace: true });
       window.location.reload();
    }
  };
// useEffect(() => {
//   const adminId = localStorage.getItem("userId");
//   const token = localStorage.getItem("token");

//   if (!adminId || !token) return;

//   axios
//     .get(`${process.env.REACT_APP_API_BASE_URL}/api/users/admin/${adminId}`, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     })
//     .then((res) => {
//       setAdminName(res.data?.username || "Admin");
//       setUserType(res.data?.usertype||"Admin")
//     })
//     .catch((err) => {
//       console.error("Admin fetch failed:", err);
//     });
// }, []);

useEffect(() => {
  const userType = localStorage.getItem("username");
  const storedDesignation = localStorage.getItem("designation");

  if (userType) setUserType(userType);
  if (storedDesignation) setDesignation(storedDesignation);
}, []);


  return (
    <nav
      className="p-4 flex flex-wrap md:flex-nowrap justify-between items-center shadow-lg relative"
      style={{
        background: colors.gradientPrimary,
        color: colors.primaryText,
      }}
    >
      {/* LEFT LOGO */}
      <div className="flex items-center space-x-3 flex-shrink-0">
        <FaUserShield className="text-white h-7 w-7" />
        <h2 className="text-lg font-bold text-white">Admin Panel</h2>
      </div>

      {/* CENTER TITLE (hidden on small screens) */}
      <div className="hidden md:flex absolute left-1/2 transform -translate-x-1/2">
        <h1 className="text-white text-xl font-semibold truncate max-w-xs text-center">
          {pageTitle}
        </h1>
      </div>

      {/* RIGHT PROFILE */}
      <div className="relative mt-3 md:mt-0 profile-dropdown text-white">
        <div
          className="flex items-center space-x-3 cursor-pointer"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <i className="fas fa-user-circle text-4xl"></i>
          <div className="flex flex-col leading-tight">
            <span className="text-xs font-semibold truncate max-w-[150px]">
              Welcome, {designation}
            </span>
            <span className="text-xs opacity-90">{userType}</span>
          </div>
        </div>

        {isDropdownOpen && (
          <div className="absolute right-0 mt-2 bg-white text-black shadow-xl rounded-lg w-40 z-50">
            <Link
              to="/view-profile"
              className="block px-3 py-2 hover:bg-gray-100"
            >
              View Profile
            </Link>
            <button
              onClick={handleLogout}
              className="w-full text-left px-3 py-2 hover:bg-gray-100"
            >
              Logout
            </button>
          </div>
        )}
      </div>

      {/* MOBILE MENU BUTTON */}
      <button
        className="text-white md:hidden ml-2 mt-3 md:mt-0"
        onClick={toggleSidebar}
      >
        <i className="fas fa-bars text-3xl"></i>
      </button>
    </nav>
  );
};

export default Navbar;
